<template>
  <h1>
    Solicitud de {{ formatRequestType(requestDetail?.request.type || '') }}
  </h1>
  <br />
  <Fieldset class="w-11" :toggleable="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="text-base">Información del empleado</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Nombre:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.name
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Nómina:</label>
          <span class="pt-2 font-bold"
            >{{ requestDetail?.payroll.code }} -
            {{ requestDetail?.payroll.name }}</span
          >
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Saldo de vacaciones:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee.vacationBalance
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Numero de identificación:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee.identificationNumber
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">País de residencia:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.countryResidence
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Ciudad:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.cityResidence
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Teléfono primario:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.primaryPhone
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Sucursal:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.subsidiary
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Dirección:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.direction
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Gerencia:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.management
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Departamento:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.department
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Área:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.area
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Posición:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.position
          }}</span>
        </div>
      </div>

      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Turno:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.employee?.shift
          }}</span>
        </div>
      </div>
    </div>
  </Fieldset>
  <Fieldset class="w-11 mt-3 mb-4" :toggleable="true">
    <template #legend>
      <div class="flex align-items-center text-primary">
        <span class="text-base">Detalle de la solicitud</span>
      </div>
    </template>
    <div class="grid">
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Estado Global:</label>
          <span class="pt-2 font-bold">{{
            formatRequestState(requestDetail?.request.globalStatus || '')
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Peso acumulado:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.request.weight
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Número de Aprobadores:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.request.approversCount
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Número de Aprobados:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.request.approvedCount
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Tipo:</label>
          <span class="pt-2 font-bold">{{
            formatRequestType(requestDetail?.request.type || '')
          }}</span>
        </div>
      </div>
      <template v-if="requestDetail?.request.license">
        <div class="lg:col-4 md:col-6 col-12">
          <div class="flex flex-column w-auto">
            <label class="text-base font-medium">Observación:</label>
            <span class="pt-2 font-bold">{{
              requestDetail?.request.license.observation
            }}</span>
          </div>
        </div>
        <div class="lg:col-4 md:col-6 col-12">
          <div class="flex flex-column w-auto">
            <label class="text-base font-medium">Adjunto(s):</label>
            <div class="flex flex-row w-12 pt-2">
              <Button
                v-for="file of requestDetail.request.license.files"
                v-tooltip.bottom="'ver adjunto'"
                class="action-btn view hover:text-blue-800 mr-2"
                severity="secondary"
                icon="pi pi-file"
                @click="downloadAttachment(file)"
              ></Button>
            </div>
          </div>
        </div>
      </template>
      <template v-if="requestDetail?.request.vacation">
        <div class="lg:col-4 md:col-6 col-12">
          <div class="flex flex-column w-auto">
            <label class="text-base font-medium">Observación:</label>
            <span class="pt-2 font-bold">{{
              requestDetail?.request.vacation.observation
            }}</span>
          </div>
        </div>
        <div class="lg:col-4 md:col-6 col-12">
          <label class="text-base font-medium">Adjunto:</label>
          <Button
            v-if="requestDetail?.request.vacation.file"
            v-tooltip.bottom="'ver adjunto'"
            class="action-btn view hover:text-blue-800 mr-2 pt-2"
            severity="secondary"
            icon="pi pi-file"
            @click="downloadAttachment(requestDetail?.request.vacation.file)"
          ></Button>
        </div>
      </template>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Cantidad:</label>
          <span class="pt-2 font-bold">{{
            requestDetail?.request.quantity
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de inicio:</label>
          <span class="pt-2 font-bold">{{
            formatDate(String(requestDetail?.request.dateInit))
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Fecha de Fin:</label>
          <span class="pt-2 font-bold">{{
            formatDate(String(requestDetail?.request.dateEnd))
          }}</span>
        </div>
      </div>
      <div class="lg:col-4 md:col-6 col-12">
        <div class="flex flex-column w-auto">
          <label class="text-base font-medium">Creado en:</label>
          <span class="pt-2 font-bold">{{
            formatDate(String(requestDetail?.request.createdAt))
          }}</span>
        </div>
      </div>
      <div class="col-12">
        <Divider />
        <h4>Flujo de aprobación</h4>
        <DataTable :value="requestDetail?.request.approverSteps">
          <template
            #empty
            v-if="requestDetail?.request.origin === 'PAYROLLSYSTEM'"
            class="flex flex-justify-center"
          >
            Solicitud creada desde el sistema de nómina
          </template>
          <template #empty v-else class="flex flex-justify-center">
            <i class="pi pi-spin pi-spinner" style="font-size: 1rem"></i>
            cargando...
          </template>
          <Column field="approver.name" header="Nombre"></Column>
          <Column field="resolutionDate" header="Fecha y hora">
            <template #body="{ data, field }">
              <span v-local-date="data[field]" v-if="data[field]"></span>
              <span class="text-600 font-medium" v-else>Sin definir</span>
            </template>
          </Column>
          <Column field="weight" header="Prioridad"></Column>
          <Column field="resolutionStatus" header="Estado">
            <template #body="slotProps">
              <Tag
                :value="formatRequestState(slotProps.data.resolutionStatus)"
                :severity="getStatusLabel(slotProps.data.resolutionStatus)"
              >
              </Tag>
            </template>
          </Column>
          <Column field="resolutionComment" header="Comentario"></Column>
        </DataTable>
      </div>
    </div>
  </Fieldset>
  <Footer>
    <ConfirmDialog group="templating">
      <template #message="slotProps">
        <div
          class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border"
        >
          <Textarea
            placeholder="Ej. Solicitud aprobada"
            class="h-10rem w-20rem"
            v-model="resolutionComment"
          ></Textarea>
        </div>
      </template>
    </ConfirmDialog>
    <Button
      class="mt-2 font-light h-2rem mr-2 text-sm"
      severity="secondary"
      @click="back"
    >
      <label class="text-sm font-medium cursor-pointer">Volver</label>
    </Button>
    <template v-if="isValidToUpdate && from !== 'history'">
      <Button
        class="mt-2 font-light h-2rem mr-2 text-sm"
        severity="danger"
        @click="confirmResolution($event, 'REJECTED')"
      >
        <label class="text-sm font-medium cursor-pointer">Rechazar</label>
      </Button>
      <Button
        class="mt-2 font-light text-sm h-2rem"
        severity="primary"
        @click="confirmResolution($event, 'APPROVED')"
      >
        <label class="text-sm font-medium cursor-pointer">Aprobar</label>
      </Button>
    </template>
  </Footer>
</template>
<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import RequestDetail from '../models/ApprovalRequestDetail'
  import {
    createRequestResolution,
    getRequestDetail,
  } from '../services/ApprovalRequestService'
  import { formatRequestType } from '@/shared/utils/formatRequestType'
  import { useRoute } from 'vue-router'
  import Footer from '@/shared/components/Footer.vue'
  import Tag from 'primevue/tag'
  import router from '@/router'
  import useNotifications from '@/store/notification'
  import useLoading from '@/store/load'
  import { useConfirm } from 'primevue/useconfirm'
  import { useUserStore } from '@/store/user'
  import { storeToRefs } from 'pinia'
  import { useRequestStore } from '@/store/requestBackup'
  import { getFileUrlPresigned } from '@/shared/services/fileService'
  import { formatDate } from '@/shared/utils/formatDate'
  const path = useRoute()
  const requestDetail = ref<RequestDetail>()
  const resolutionComment = ref<string>('')
  const notificationStore = useNotifications()
  const loadingStore = useLoading()
  const { user } = storeToRefs(useUserStore())
  const requestStore = useRequestStore()
  const requestNotFoundModal = ref(false)
  const requestId = ref<string>()
  const from = ref<string>()
  const isFromApproverHistory = ref(false)

  onMounted(async () => {
    loadingStore.setLoadingState()
    requestId.value = String(path.params.id)
    from.value = String(path.params.from)

    requestDetail.value = await getRequestDetail(requestId.value)
    if (!requestDetail.value) {
      requestNotFoundModal.value = true
    }
    isBackupRequest.value = requestStore.getRequest
    loadingStore.dismissLoadingState()
  })

  const isBackupRequest = ref(false)

  const back = () => {
    if (from.value === 'history') router.push('/requestHistory')
    else router.push('/requestApprover')
  }

  const confirm = useConfirm()

  const confirmResolution = (event: any, state: string) => {
    confirm.require({
      group: 'templating',
      header: 'Mensaje de confirmación',
      message: 'Ingresa un comentario de confirmación.',
      icon: 'pi pi-exclamation-circle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectClass: 'p-button-sm',
      acceptClass: 'p-button-outlined p-button-sm',
      accept: async () => {
        await onResolutionRequest(state)
      },
      reject: () => {},
    })
  }

  const onResolutionRequest = async (state: string) => {
    loadingStore.setLoadingState()
    requestStore.setId('')
    requestStore.setRequest(false)

    const response = await createRequestResolution(
      {
        resolutions: [
          {
            approvalFlowRequestId:
              requestDetail.value?.request.id.toString() || '',
            resolutionComment: resolutionComment.value,
            resolutionMethod: 'RequestModule',
            resolutionState: state,
          },
        ],
      },
      isBackupRequest.value
    )

    loadingStore.dismissLoadingState()

    if (response === 'OK') {
      notificationStore.addSuccesNotification({
        detail: `200`,
        severity: 'success',
        summary: `Solicitud ${
          state === 'APPROVED' ? 'aprobada' : 'rechazada'
        } exitosamente`,
      })

      router.push('/requestApprover')
    }
  }

  const isValidToUpdate = computed(() => {
    return (
      (requestDetail.value?.request.globalStatus === 'PENDING' &&
        requestDetail.value?.request.approverSteps[
          requestDetail.value?.request.approverSteps.length - 1
        ].approver.id === user.value?.approverId) ||
      isBackupRequest.value
    )
  })

  const downloadAttachment = async (fileKey: string) => {
    if (!fileKey) return

    if (fileKey.includes('http')) {
      window.open(fileKey, '_blank')
      return
    }

    const fileUrl = await getFileUrlPresigned(fileKey)
    window.open(fileUrl, '_blank')
  }

  const formatRequestState = (state: string) => {
    switch (state) {
      case 'PENDING':
        return 'Pendiente'
      case 'REJECTED':
        return 'Rechazado'
      case 'APPROVED':
        return 'Aprobado'
      default:
        return 'Pendiente'
    }
  }

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'APPROVED':
        return 'success'
      case 'PENDING':
        return 'warning'
      case 'REJECTED':
        return 'danger'
      default:
        return 'warning'
    }
  }
</script>
<style scoped>
  tabla {
    margin-top: 1rem;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1),
      0px 4px 5px -2px rgba(0, 0, 0, 0.12),
      0px 10px 15px -5px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    width: 90%;
  }

  :deep(.p-column-title) {
    font-size: 14px;
  }

  :deep(.p-datatable-tbody) {
    font-size: 14px;
  }

  .action-btn {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
